import { Injectable } from '@angular/core';
import { Fetcher } from '@shared/http/fetcher';
import type { CarerContract } from '@shared/modules/carer-contracts/carer-contract';

@Injectable({
    providedIn: 'root',
})
export class CarerContractFetcher extends Fetcher<CarerContract> {
    readonly modelName: string = 'CarerContract';

    get resourceName(): string {
        return 'carer-contracts';
    }
}
